import { render, staticRenderFns } from "./annual-return.vue?vue&type=template&id=4494ee1a"
import script from "./annual-return.vue?vue&type=script&lang=js"
export * from "./annual-return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports